module.exports = __webpack_public_path__ + "img/guide_finish.8dd93428.svg";